import React from 'react';
import { Link } from 'react-router-dom';
import {  
  FaInstagram, 
  FaLinkedinIn, 
  FaEnvelope, 
  FaPhone, 
  FaMapMarkerAlt

} from 'react-icons/fa';
import { motion } from 'framer-motion';


const Footer: React.FC = () => {

  return (
    <footer className="py-16 text-white font-['Gentium_Book_Plus'] bg-black rounded-2xl">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo and Tagline Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="mb-4">
              <img src='/images/logo-footer-2.png' alt='footer logo' className="mb-4" />
             
              <p className="text-sm text-white mt-2">
               India's first mental health practice which priortizes affordability in a sustainable manner !
              </p>
            </div>

            <div className="flex space-x-4 mt-4">
            
              <Link to="https://www.instagram.com/grehpraveshtherapy" className="text-2xl hover:text-pink-600">
                <FaInstagram />
              </Link>
              <Link to="https://in.linkedin.com/company/greh-pravesh-therapy-healing-centre" className="text-2xl hover:text-blue-600">
                <FaLinkedinIn />
              </Link>
              <Link to="mailto:grehpraveshtherapy@gmail.com" className="text-2xl hover:text-green-600">
              <FaEnvelope />
              </Link>
             
            </div>
          </motion.div>

          {/* Quick Links Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <h3 className="text-2xl font-bold mb-6 text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="hover:text-sage transition-colors">About Us</Link></li>
              <li><Link to="/trauma" className="hover:text-sage transition-colors">Trauma Services</Link></li>
              <li><Link to="/services/couples-therapy" className="hover:text-sage transition-colors">Couples Therapy</Link></li>
              <li><Link to="/services/family-therapy" className="hover:text-sage transition-colors">Family Therapy</Link></li>
              <li><Link to="/our-team" className="hover:text-sage transition-colors">Our Therapists</Link></li>
              <li><Link to="/training&workshops" className="hover:text-sage transition-colors">Workshops</Link></li>
             
            </ul>
          </motion.div>

          {/* Services Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            <h3 className="text-2xl font-bold mb-6 text-white">Our Services</h3>
            <ul className="space-y-2">
              <li><Link to="/services/individual-therapy" className="hover:text-sage transition-colors">Individual Counseling</Link></li>
              <li><Link to="/relationship-concerns" className="hover:text-sage transition-colors">Relationship Counseling</Link></li>
              <li><Link to="/trauma" className="hover:text-sage transition-colors">Trauma Recovery</Link></li>
              <li><Link to="/services/family-therapy" className="hover:text-sage transition-colors">Family Therapy</Link></li>
              <li><Link to="/training&workshops" className="hover:text-sage transition-colors">Mental Health Workshops</Link></li>
            </ul>
          </motion.div>

          {/* Contact Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <h3 className="text-2xl font-bold mb-6 text-white">Contact Us</h3>
            <div className="space-y-3">
              <p className="flex items-center">
                <FaMapMarkerAlt className="mr-3 text-sage" />
                4/20, WEST PATEL NAGAR, NEW DELHI-110008 
              </p>
              <p className="flex items-center">
                <FaPhone className="mr-3 text-sage" />
                +91 8591049845 
              </p>
              <p className="flex items-center">
                <FaEnvelope className="mr-3 text-sage" />
                grehpraveshtherapy@gmail.com
              </p>
            </div>

            <div className="mt-6">
              <h4 className="font-semibold mb-2">Business Hours</h4>
              <p>Monday - Sunday: 10 AM - 9 PM</p>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="mt-12 pt-8 border-t border-sage text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.8 }}
        >
          <p className="text-sm">
            &copy; {new Date().getFullYear()} Greh Pravesh. All rights reserved. | 
            Website by<a href="https://rnahealthtech.com" className="ml-2 hover:underline">RNA HealthTech</a> 
          </p>
        </motion.div>
      </div>

    </footer>
  );
};

export default Footer;